var _defs, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhyus4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4a00e8;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 6px;\n      }\n\n      .cls-2 {\n        fill: #e0ef4d;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 54.94,
    y: 150.36,
    width: 92.46,
    height: 92.46,
    rx: 10,
    ry: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.49,190.02l-11.01-7.84c-.78-.56-1.83-.56-2.61,0l-11.01,7.84c-1.49,1.06-3.56,0-3.56-1.83v-37.82h31.74v37.82c0,1.83-2.07,2.89-3.56,1.83Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 66.52,
    y: 221.8,
    width: 42.73,
    height: 10.05,
    rx: 5.02,
    ry: 5.02
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 75.38,
    y: 57.9,
    width: 92.46,
    height: 92.46,
    rx: 10,
    ry: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.92,97.55l-11.01-7.84c-.78-.56-1.83-.56-2.61,0l-11.01,7.84c-1.49,1.06-3.56,0-3.56-1.83V57.9h31.74v37.82c0,1.83-2.07,2.89-3.56,1.83Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 86.95,
    y: 129.34,
    width: 42.73,
    height: 10.05,
    rx: 5.02,
    ry: 5.02
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 147.41,
    y: 150.36,
    width: 92.46,
    height: 92.46,
    rx: 10,
    ry: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.95,190.02l-11.01-7.84c-.78-.56-1.83-.56-2.61,0l-11.01,7.84c-1.49,1.06-3.56,0-3.56-1.83v-37.82h31.74v37.82c0,1.83-2.07,2.89-3.56,1.83Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 158.98,
    y: 221.8,
    width: 42.73,
    height: 10.05,
    rx: 5.02,
    ry: 5.02
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M204.4,67.95l12.67-4.1c4.08-1.32,8.51,.52,10.46,4.33l6.06,11.86c.84,1.64,2.17,2.97,3.8,3.8l11.86,6.06c3.82,1.95,5.65,6.38,4.33,10.46l-4.1,12.67c-.57,1.75-.57,3.63,0,5.38l4.1,12.67c1.32,4.08-.52,8.51-4.33,10.46l-11.86,6.06c-1.64,.84-2.97,2.17-3.8,3.8l-6.06,11.86c-1.95,3.82-6.38,5.65-10.46,4.33l-12.67-4.1c-1.75-.57-3.63-.57-5.38,0l-12.67,4.1c-4.08,1.32-8.51-.52-10.46-4.33l-6.06-11.86c-.84-1.64-2.17-2.97-3.8-3.8l-11.86-6.06c-3.82-1.95-5.65-6.38-4.33-10.46l4.1-12.67c.57-1.75,.57-3.63,0-5.38l-4.1-12.67c-1.32-4.08,.52-8.51,4.33-10.46l11.86-6.06c1.64-.84,2.97-2.17,3.8-3.8l6.06-11.86c1.95-3.82,6.38-5.65,10.46-4.33l12.67,4.1c1.75,.57,3.63,.57,5.38,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 187.15,
    cy: 101.16,
    r: 9.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 216.29,
    cy: 130.3,
    r: 9.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 181.59,
    y1: 135.86,
    x2: 221.84,
    y2: 95.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyus4);
export default __webpack_public_path__ + "static/media/whyus4.580011a5a1afb1fc58783102b1b6ca16.svg";
export { ForwardRef as ReactComponent };